import { Component, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DOMHandlerService } from '../../../services/domhandler.service';
import { NewsletterInputFieldComponent } from './newsletter-input-field/newsletter-input-field.component';
import { RichTextComponent } from '../../common/rich-text/rich-text.component';
import { ShopService } from '../../../services/shop.service';

@Component({
    selector: 'app-newsletter',
    imports: [
        ReactiveFormsModule,
        NewsletterInputFieldComponent,
        RichTextComponent,
    ],
    templateUrl: './newsletter.component.html',
})
export class NewsletterComponent {
    data = input.required<Newsletter>();
    domHandler = inject(DOMHandlerService);
    shopService = inject(ShopService);
}

type Newsletter = {
    title?: string;
    subTitle?: string;
    hasAddress: boolean;
};
